import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { BsCheck2Circle } from "react-icons/bs";
import Login from "../../pages/common/Login";

export default function SuccessModal({ show, onHide }) {
    const [loginModal, setLoginModal] = useState(false);
    const handleLoginOpen = () => {
        setLoginModal(true);
        onHide();
    };
    const handleLoginClose = () => setLoginModal(false);
    return (
        <>
            <Modal size="md" aria-labelledby="contained-modal-title-vcenter" className="modal-details success_modal" show={show} centered>
                <Modal.Header className="justify-content-between">
                    <Modal.Title>Log in to unlock a better search experience.</Modal.Title>
                    {/* <Modal.Title>Email agent</Modal.Title> */}
                    <button type="button" onClick={onHide} className="close-icon-style">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body className="success_body">
                    <div className="success_text">
                        <BsCheck2Circle color="#198754" />
                        <p>Success!</p>
                    </div>
                    <h6>Your message is on it's way...</h6>
                    <h6>Our partner agent will connect with you soon.</h6>
                </Modal.Body>
                <Modal.Footer>
                    <button className="button reset_btn me-2" onClick={onHide}>
                        Close
                    </button>
                    <button className="button" onClick={handleLoginOpen}>
                        Sign in
                    </button>
                    {/* <button className="button btn_success">OK</button> */}
                </Modal.Footer>
            </Modal>
            <Login show={loginModal} handleHide={handleLoginClose} onShow={handleLoginOpen} />
        </>
    );
}
